import Vue from "vue";
import _ from "lodash";
import API from "@/api/index";
import TFMService from "@/api/service";

const MODULE_NAME = "tsc";

const MUTATION_TYPES = {
	ADD_TSC: "ADD_TSC",
	SET_MANAGE_INFO: "SET_MANAGE_INFO",
	CLEAR_TSCS: "CLEAR_TSCS",
	UPDATE_TSC_DATA: "UPDATE_TSC_DATA"
};

const ACTION_TYPES = {
	FETCH_TSC_METADATA: "FETCH_METADATA",
	FETCH_TSC_MANAGE_INFO: "FETCH_MANAGE_INFO",
	FETCH_ALL_DEVICES: "FETCH_ALL_DEVICES",
	FETCH_TSCS: "FETCH_TSCS"
};

export default {
	MODULE_NAME,
	MUTATION_TYPES,
	ACTION_TYPES,
	namespaced: true,

	state: {
		tscs: {},
		devices: {},
		manageInfo: {}
	},

	mutations: {
		[MUTATION_TYPES.ADD_TSC](state, payload) {
			const pushDevice = r => {
				// create defaults
				const device = Object.assign(
					{
						deviceId: r.controllerid,
						deviceName: r.description,
						manageInfo: null,
						$deviceTypeId: 2
					},
					r
				);
				Vue.set(state.devices, device.deviceId, device);
			};
			if (_.isEmpty(payload)) return;
			if (Array.isArray(payload)) {
				_.map(payload, pushDevice);
			} else {
				pushDevice(payload);
			}
		},

		[MUTATION_TYPES.SET_MANAGE_INFO](state, { id, data }) {
			Vue.set(state.manageInfo, id, data);
		},

		[MUTATION_TYPES.UPDATE_TSC_DATA](state, { index, data }) {
			Vue.set(state.devices, index, Object.assign(state.devices[index], data));
		},

		[MUTATION_TYPES.CLEAR_TSCS](state) {
			Vue.set(state, "devices", {});
		}
	},

	actions: {
		async [ACTION_TYPES.FETCH_TSC_MANAGE_INFO](context, { id }) {
			const data = await TFMService.getTSCManageInfo(id);
			context.commit(MUTATION_TYPES.SET_MANAGE_INFO, { id, data });
		},

		async [ACTION_TYPES.FETCH_TSC_METADATA](context, p) {
			const index = context.getters.indexByIdentifier(p.id);
			if (index === -1) {
				throw new Error(
					`Tried to fetch TSC metadata for TSC with device ID ${p.id} but it didn't exist in the state (yet?).`
				);
			}
			const data = {};
			data[ACTION_TYPES.FETCH_TSC_METADATA + "_start"] = _.now();
			context.commit(MUTATION_TYPES.UPDATE_TSC_DATA, { index, data });

			return await Promise.all([
				context
					.dispatch(ACTION_TYPES.FETCH_TSC_MANAGE_INFO, p)
					.catch(err => console.warn("Found bad manage info for TSC", p, err))
			]);
		},

		[ACTION_TYPES.FETCH_TSCS](context) {
			return new Promise((resolve, reject) => {
				API.getJson(API.ENDPOINTS.GET_TSC_BY_USER)
					.then(json => {
						if (json) {
							if (json.length === 1 && json[0].retCode == -1) {
								throw new Error(
									"FETCH_TSCs Error: " +
										(json[0].retMsg || "Invalid server response.")
								);
							}
							context.commit(MUTATION_TYPES.CLEAR_TSCS);
							context.commit(MUTATION_TYPES.ADD_TSC, json);
						}
						resolve();
					})
					.catch(err => {
						console.error(err);
						reject(err);
					});
			});
		},

		[ACTION_TYPES.FETCH_ALL_DEVICES](context) {
			return context.dispatch(ACTION_TYPES.FETCH_TSCS);
		}
	},
	getters: {
		allDevices(state) {
			return state.devices;
		},

		devicePosition() {
			return device => {
				if (device === null || device === void 0) return null;
				if (!("latitude" in device) || !("longitude" in device)) return null;
				return [device.latitude, device.longitude];
			};
		},

		byIdentifier(state) {
			return identifier => {
				return state.devices[identifier];
			};
		},

		manageInfoByID(state) {
			return id => state.manageInfo[id];
		},

		statusMetadata() {
			return () => {
				return {};
			};
		},

		indexByIdentifier(state) {
			return identifier => (state.devices[identifier] ? identifier : -1);
		}
	}
};
